import { render } from "./ManageVendors.vue?vue&type=template&id=003a70ac&scoped=true"
import script from "./ManageVendors.vue?vue&type=script&lang=js"
export * from "./ManageVendors.vue?vue&type=script&lang=js"

import "./ManageVendors.vue?vue&type=style&index=0&id=003a70ac&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003a70ac"]])

export default __exports__